export function validateConsistent(config) {
    const qty = Number(config.expectedQuantity);
    if (!Number.isFinite(qty) || qty <= 0) {
        return "Expected quantity must be > 0.";
    }

    const p = Number(config.targetPrice);
    if (!Number.isFinite(p) || p <= 0) {
        return "Price must be > 0.";
    }
    const lot = Number(config.lotSize);
    if (Number.isFinite(lot) && lot > 0) {
        if (qty < lot) return `Expected quantity must be at least 1 lot (${lot}).`;
        if (qty % lot !== 0) return `Expected quantity must be a multiple of lot size (${lot}).`;
    }

    return null;
}
